<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      requiresAuthentication: false,
      userHasIncompleteProfile: false,
    };
  },
  computed: {
    ...mapState('user', {
      user: (state) => state,
    }),
  },
  mounted() {
    this.isAuthenticationRequired();

    window.setInterval(() => {
      this.isAuthenticationRequired();
    }, 6000);

    this.$bus.$on('bus:axios-interceptor:requires-reauthentication', () => {
      this.requiresAuthentication = true;
    });
    this.$bus.$on('bus:reauthentication-form:success', () => {
      this.requiresAuthentication = false;
    });
  },

  methods: {
    ...mapActions('user', [
      'reAuthenticateUser',
    ]),
    isAuthenticationRequired() {
      if (this.user.re_auth_next_required_at_utc === null) return false;
      const dateToday = new Date();
      const reauthenticateDateTime = new Date(this.user.re_auth_next_required_at_utc).getTime();
      this.requiresAuthentication = this.user.re_auth_is_required || dateToday.getTime() > reauthenticateDateTime;
      this.userHasIncompleteProfile = this.user.profile_completion < 100;
      return this.requiresAuthentication;
    },
  },
  render() {
    return this.$slots.default({
      requiresAuthentication: this.requiresAuthentication,
      userHasIncompleteProfile: this.userHasIncompleteProfile,
    });
  },
};
</script>
